import { render, staticRenderFns } from "./AdsAccountAdd.vue?vue&type=template&id=365f284a&"
import script from "./AdsAccountAdd.vue?vue&type=script&lang=js&"
export * from "./AdsAccountAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports